import { render } from "./TheHeader.vue?vue&type=template&id=6ae1c378&scoped=true&ts=true&lang=pug"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=6ae1c378&scoped=true&lang=scss"

import exportComponent from "/Users/ferca/Projects/ferca.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae1c378"]])

export default __exports__